import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectRoutePOS = () => {
  const user = useSelector((state) => state.user.user);
  console.log("POS GUARD USER:", user);

  // 🟡 WAIT for redux to hydrate
  if (user === undefined) {
    return null; // or loader
  }

  // ❌ Not logged in
  if (user === null) {
    return <Navigate to="/login" replace />;
  }

  // ❌ Wrong role
  if (user.role !== "FRANCHISE") {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectRoutePOS;
